package com.example.monetix.db

import app.cash.sqldelight.SuspendingTransacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.example.monetix.db.composeApp.newInstance
import com.example.monetix.db.composeApp.schema
import kotlin.Unit

public interface MonetixDatabase : SuspendingTransacter {
  public val accountQueries: AccountQueries

  public val brandQueries: BrandQueries

  public val budgetQueries: BudgetQueries

  public val categoryQueries: CategoryQueries

  public val favoriteTemplateQueries: FavoriteTemplateQueries

  public val financingQueries: FinancingQueries

  public val merchantLocationQueries: MerchantLocationQueries

  public val piggyBankQueries: PiggyBankQueries

  public val recurringExpenseQueries: RecurringExpenseQueries

  public val savingsGoalQueries: SavingsGoalQueries

  public val settingsQueries: SettingsQueries

  public val transactionQueries: TransactionQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.AsyncValue<Unit>>
      get() = MonetixDatabase::class.schema

    public operator fun invoke(driver: SqlDriver): MonetixDatabase =
        MonetixDatabase::class.newInstance(driver)
  }
}
